import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';
import PrebuiltBetAvantgarde from 'modules/prebuilt-bets/prebuilt-bet/view/avantgarde/index.js';
import PrebuiltBetUtils from 'modules/prebuilt-bets/prebuilt-bet/utils.js';
import MarketSignpostingIcons from 'modules/aggregated-market-pane/signposting-icons/index.js';
import { useBetBuilderAnalyticsContext } from 'modules/prebuilt-bets/prebuilt-bet/hooks/index.js';

const { getSeparatorTranslationKey } = MojitoPresentation.Utils.ParticipantSeparator;
const {
    FlexPane,
    Image,
    Text,
    DateTime,
    NeutralVenueIndicator,
    SportIcon,
    ParticipantIconsInline,
} = MojitoPresentation.Components;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;

const Header = ({ config, event, market, promotionText, stringResolver }) => (
    <FlexPane class="ta-PrebuiltBetHeader" config={config.headerContainer}>
        {config.showMatchAccaIcon && <Image config={config.matchAccaIcon} />}
        <FlexPane config={config.typeAndTimeHeader}>
            <FlexPane config={config.sportIconAndTypeContainer}>
                {event?.sportId && <SportIcon sportId={event.sportId} config={config.sportIcon} />}
                <Text config={config.typeName}>{event?.typeName}</Text>
            </FlexPane>
            <FlexPane config={config.timeAndTypeContainer}>
                <Text config={config.startTime}>
                    <DateTime config={config.startTimeFormat} dateTime={event?.startTime} />
                </Text>
                <MarketSignpostingIcons
                    config={config.signpostingIcons}
                    earlyPayout={PrebuiltBetUtils.getEarlyPayout(market)}
                />
                {event?.neutral && <NeutralVenueIndicator config={config.neutralVenueIndicator} />}
            </FlexPane>
        </FlexPane>
        <FlexPane config={config.headerTextContainer}>
            <ParticipantIconsInline
                participants={event?.participants}
                sportId={event?.sportId}
                homeAway={event?.homeAway}
                separator={stringResolver.resolveString(
                    getSeparatorTranslationKey(event?.homeAway)
                )}
                config={config.participantsIconInline}
            />
        </FlexPane>
        {Boolean(promotionText) && (
            <FlexPane config={config.promotionTextContainer} class="ta-PrebuiltBetPromotionText">
                <Text config={config.promotionText}>{promotionText}</Text>
            </FlexPane>
        )}
    </FlexPane>
);

const PrebuiltBetBuilderAvantgarde = props => {
    const {
        mojitoTools: { config, stringResolver },
        event,
        market,
        promotionText,
        boostedMarket,
        onEventClick,
        shouldRequestData,
    } = props;

    const analyticsContext = useBetBuilderAnalyticsContext(boostedMarket);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetAvantgarde
                config={config.view}
                market={market}
                boostedMarket={boostedMarket}
                event={event}
                onEventClick={onEventClick}
                shouldRequestData={shouldRequestData}
                class={'ta-PrebuiltBetBuilder'}
            >
                {config.view.showCardHeader && (
                    <Header
                        config={config}
                        event={event}
                        market={market}
                        promotionText={promotionText}
                        stringResolver={stringResolver}
                    />
                )}
            </PrebuiltBetAvantgarde>
        </AnalyticsContextExtender>
    );
};

export default PrebuiltBetBuilderAvantgarde;
